<template>
  <div class="kundenapp-hinweis d-flex flex-column flex-md-row align-items-center justify-content-center">
    <div class="kundenapp-icon mb-2 mb-md-0 mr-md-3">
      <b-icon icon="phone-vibrate" />
    </div>
    <div class="text-center text-md-left mb-3 mb-md-0 mr-md-4">
      <div class="kundenapp-titel">{{ $t("message.kundenapp_titel") }}</div>
      <div class="kundenapp-text">{{ $t("message.kundenapp_text") }}</div>
    </div>
    <div class="kundenapp-stores">
      <a
        v-if="appStoreUrl"
        :href="appStoreUrl"
        target="_blank"
        rel="noopener"
        class="btn btn-dark store-button">
        <svg viewBox="0 0 384 512" class="store-logo" aria-hidden="true">
          <path fill="currentColor" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
        </svg>
        <span class="store-label">
          <small>{{ $t("message.kundenapp_appstore_klein") }}</small>
          App Store
        </span>
      </a>
      <a
        v-if="googlePlayUrl"
        :href="googlePlayUrl"
        target="_blank"
        rel="noopener"
        class="btn btn-dark store-button">
        <svg viewBox="0 0 512 512" class="store-logo" aria-hidden="true">
          <path fill="currentColor" d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
        </svg>
        <span class="store-label">
          <small>{{ $t("message.kundenapp_googleplay_klein") }}</small>
          Google Play
        </span>
      </a>
    </div>
  </div>
</template>

<script>

  /**
   * Hinweis auf die BIO-TECH Kundenapp mit Links in die App Stores (im Footer),
   * damit Kunden animiert werden, die App zu installieren.
   */
  export default {
    name: 'KundenappHinweis',
    data () {
      return {
        // App-Store-Link folgt, sobald die iOS-App veröffentlicht ist (leer = Button ausgeblendet)
        appStoreUrl: '',
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=at.biotech.scanner'
      }
    }
  }

</script>

<style scoped>

  .kundenapp-hinweis {
    color: #fff;
  }
  .kundenapp-icon {
    font-size: 2.5rem;
    line-height: 1;
  }
  .kundenapp-titel {
    font-size: 1.1rem;
    font-weight: bold;
  }
  .kundenapp-text {
    font-size: 0.9rem;
  }
  .kundenapp-stores {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem;
  }
  .store-button {
    display: inline-flex;
    align-items: center;
    text-align: left;
    padding: 0.35rem 0.9rem;
    min-width: 150px;
    line-height: 1.1;
    background-color: #000;
    border-color: #a6a6a6;
  }
  .store-button:hover {
    background-color: #222;
  }
  .store-logo {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.6rem;
    flex-shrink: 0;
  }
  .store-label {
    font-size: 1.05rem;
    font-weight: 600;
  }
  .store-label small {
    display: block;
    font-size: 0.65rem;
    font-weight: normal;
  }

</style>
